import { formatInstantByPattern } from "@/lib/datetime/display";
import { tokenizeDateFormat } from "@/lib/datetime/pattern";

export function mapHref(
  address: string,
  lng: string,
  lat: string,
  provider: string,
): string {
  const name = encodeURIComponent(address);

  if (!lng || !lat) {
    return `https://uri.amap.com/search?keyword=${name}`;
  }

  return provider === "bmap"
    ? `https://api.map.baidu.com/marker?location=${lat},${lng}&title=${name}&content=${name}&output=html&coord_type=bd09ll`
    : `https://uri.amap.com/marker?position=${lng},${lat}&name=${name}`;
}

const SESSION_SEGS = tokenizeDateFormat("yyyy-MM-dd HH:mm");

export function formatSession(startAt: string, endAt: string): string {
  const start = startAt ? formatInstantByPattern(startAt, SESSION_SEGS) : "";
  const end = endAt ? formatInstantByPattern(endAt, SESSION_SEGS) : "";
  if (start && end) return `${start} ~ ${end}`;

  return start || end;
}
